import React from 'react';
import styled from 'styled-components';
import { media, theme } from '@marketing-site/styles';
import { Box } from '@mui/material';

export interface StepComponentProps {
  stepNumber: number;
  title: string;
  description?: string;
}

export const StepComponent = (props: StepComponentProps) => {
  return (
    <Container>
      <Box
        width={32}
        height={32}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <StepNumber>{props.stepNumber}</StepNumber>
      </Box>
      <StepContent>
        <StepTitle>{props.title}</StepTitle>
        <StepDescription>{props.description || ''}</StepDescription>
      </StepContent>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 16px;
`;

const StepNumber = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  background-color: ${theme.colors.lightsky};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.white};
  font-size: 20px;
  font-weight: 800;
`;
const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const StepTitle = styled.h4`
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  margin: 0;
`;

const StepDescription = styled.p`
  font-size: 16px;
  line-height: 24px;
  margin: 0;
`;
